
import { Component, Vue, Prop } from 'vue-property-decorator'
import FetchWrapper from '@/classes/fetchWrapper'

Vue.prototype.$multiwatch = function (props, watcher) {
  var iterator = function (prop) {
    this.$watch(prop, watcher)
  }
  props.forEach(iterator, this)
}

const CreateUserModalProps = Vue.extend({
  props: {
    canCancel: Boolean,
    close: Boolean,
    role: String // 'tutor' || 'teacher'
  }
})

@Component
export default class CreateUserModal extends CreateUserModalProps {
  data () {
    return {
      isLoading: false,
      name: '',
      email: '',
      phone: '',
      password: '',
      formDataValid: false
    }
  }

  get isComponentModalActive () {
    return this.close
  }

  created () {
    this.$multiwatch(['name', 'email', 'phone', 'password'], function () {
      const valid = this.$refs.form.checkValidity()
      this.formDataValid = valid
    })
  }

  async createUser () {
    try {
      this.isLoading = true

      var data = {
        voucher: '',
        name: this.name,
        email: this.email,
        phone: this.phone,
        pwd: this.password
      }

      var endpoint = 'createTutor'
      if (this.role === 'teacher') {
        endpoint = 'createTeacher'
      }
      const resp = await FetchWrapper.post(`${process.env.VUE_APP_SERVERURL}/${endpoint}`, data)

      this.isLoading = false

      this.$buefy.dialog.confirm({
        title: 'Success',
        message: `User ${this.role} created.`,
        onConfirm: () => {
          this.$emit('created')
          this.name = ''
          this.email = ''
          this.phone = ''
          this.password = ''
          this.formDataValid = false
        },
        canCancel: false
      })
    } catch (e) {
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not create ${this.role}. Reason: ${e}`,
        canCancel: false
      })
    }
  }
}
